module.exports = __webpack_public_path__ + "static/brand12-c2d37391c31aa2f037ff98548e2a9550.png";